import React from "react";
import { useHistory } from "react-router-dom";
import { Menu, MenuItem, IconButton, Typography } from "@mui/material";
import { Menu as MenuIcon, AccountCircle, HelpOutline } from "@mui/icons-material";

import styled from "styled-components";
import { THEME_MAP } from "../theme";

import { signOut } from "../actions/auth";
import { useUserRoles } from "../globalstore";
import { useIsMobile } from "../hooks/useIsMobile";
import { useSidebar } from "../contexts/SidebarContext";
import { usePageTour } from "../components/onboarding/pageTours";

export function Header() {
    const history = useHistory();
    const { userRoles: { email }} = useUserRoles();
    const isMobile = useIsMobile();
    const { toggle } = useSidebar();
    const { tourKey, startTour } = usePageTour();

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        handleClose();
        signOut();
        history.push("/login");
    };

    return (
        <Head>
            <div className="header-left">
                {isMobile && (
                    <IconButton
                        onClick={toggle}
                        aria-label="Open navigation menu"
                        size="large"
                        sx={{ color: THEME_MAP["color-primary-500"] }}
                    >
                        <MenuIcon />
                    </IconButton>
                )}
            </div>
            <div className="user-menu">
                {tourKey && (
                    <IconButton
                        onClick={startTour}
                        aria-label="Replay page tour"
                        size="large"
                        sx={{ color: THEME_MAP["color-basic-600"] }}
                    >
                        <HelpOutline fontSize="large" />
                    </IconButton>
                )}
                <IconButton
                    onClick={handleClick}
                    aria-label="Account menu"
                    size="large"
                    sx={{ color: THEME_MAP["color-basic-600"] }}
                >
                    <AccountCircle fontSize="large" />
                </IconButton>
                <Menu
                    id="account-menu"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        horizontal: "right",
                        vertical: "bottom"
                    }}
                    transformOrigin={{
                        horizontal: "right",
                        vertical: "top"
                    }}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    <MenuItem disabled sx={{ opacity: "1 !important" }}>
                        <Typography variant="body2" color="textSecondary">
                            {email || "Unknown user"}
                        </Typography>
                    </MenuItem>
                    <MenuItem onClick={handleLogout}>Sign Out</MenuItem>
                </Menu>
            </div>
        </Head>
    );
}

const Head = styled.div`
	width: 100%;
	height: 56px;

	position: sticky;
	top: 0;
	z-index: 1100;

	background: ${THEME_MAP["color-basic-100"]};
	border-bottom: 1px solid ${THEME_MAP["color-basic-300"]};

	display: flex;
	justify-content: space-between;
	align-items: center;

	padding: 0 16px;

	.header-left {
		display: flex;
		align-items: center;
	}

	.user-menu {
		display: flex;
		align-items: center;
	}
`;
